import React, { useState, useEffect } from "react";
import Platform from "react-platform-js";
import ViaLogo from "./assets/via_logo.png";
import DownloadAppStoreImage from "./assets/download_app_store.png";
import DownloadGoogleAppImage from "./assets/download_google_play.png";

import Button from "@material-ui/core/Button";
import Link from "@material-ui/core/Link";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

const styles = {
  root: {
    width: "100%",
    textAlign: "center",
  },
  container: {
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: "100vh",
  },
  message: {
    margin: "40px",
  },
  downloadImageContainer: {
    width: "100%",
  },
  downloadImageAndroid: {
    width: "80%",
    maxWidth: "345px",
  },
  downloadImageIOS: {
    width: "80%",
    maxWidth: "300px",
  },
};

function App() {
  const [modalOpen, setModalOpen] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState(null);

  const DownloadButton = ({ style, href, img }) => {
    return (
      <div style={styles.downloadImageContainer}>
        <a href={href}>
          <img style={style} alt="Download Via App" src={img}></img>
        </a>
      </div>
    );
  };

  useEffect(() => {
    const scheme = "viadrivethru";
    const pathName = window.location.pathname.replace(/^\/?(.+)\/?$/, "$1");

    if (Platform.OS === "iOS") {
      setRedirectUrl(`${scheme}://${pathName}`);
    } else if (Platform.OS === "Android") {
      setModalOpen(true);

      let packageName = "com.viaDriveThru";

      if (window.location.hostname.includes("via-eg-staging.herokuapp.com")) {
        packageName = `${packageName}Test`;
      }

      setRedirectUrl(
        `intent://${pathName}#Intent;scheme=${scheme};package=${packageName};end`
      );
    }
  }, []);

  useEffect(() => {
    if (redirectUrl) {
      window.location = redirectUrl;
    }
  }, [redirectUrl]);

  if (!["Android", "iOS"].some((os) => Platform.OS === os)) {
    window.location = "https://via-eg.com";
    return null;
  }

  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <div style={styles.root}>
      <div style={styles.container}>
        <div>
          <div>
            <img alt="Via" src={ViaLogo}></img>
          </div>

          <h2 style={styles.message}>
            To use Via, you need the app. Please download it below.
          </h2>

          {redirectUrl && (
            <iframe
              title="iframe via"
              src={redirectUrl}
              style={{ display: "none" }}
            ></iframe>
          )}

          <Platform rules={{ OS: "Android" }}>
            <Dialog
              open={modalOpen}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"Open in Via?"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Open this page in Via application?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color="primary">
                  Cancel
                </Button>

                <Link
                  component={Button}
                  onClick={handleClose}
                  href={redirectUrl}
                  color="primary"
                  autoFocus
                >
                  Open
                </Link>
              </DialogActions>
            </Dialog>

            <DownloadButton
              style={styles.downloadImageAndroid}
              href="https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.viaDriveThru"
              img={DownloadGoogleAppImage}
            ></DownloadButton>
          </Platform>

          <Platform rules={{ OS: "iOS" }}>
            <DownloadButton
              style={styles.downloadImageIOS}
              img={DownloadAppStoreImage}
              href="https://itunes.apple.com/eg/app/via-drive-thru/id1406822019?mt=8"
            ></DownloadButton>
          </Platform>
        </div>
      </div>
    </div>
  );
}

export default App;
